module.exports = __webpack_public_path__ + "static/media/brand-logo.4fc80afc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/brand-logo.svg
// module id = 13359
// module chunks = 0